import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import App from "./App";

// ✅ PERFORMANCE: React Query client with optimal settings for client-side caching
// 🚫 ANALYTICS EXCLUDED: This caching system is only used by Dashboard and Email Campaigns
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,      // 5 min - data considered fresh
      cacheTime: 30 * 60 * 1000,     // 30 min - cache retained in memory
      refetchOnWindowFocus: false,   // Don't refetch on tab switch
      refetchOnReconnect: true,      // Refetch on network reconnect
      retry: 1,                      // Only retry once on failure
      retryDelay: 1000,              // 1s between retries
    },
  },
});

console.log('StormOps Dispatch client cache initialized');

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
    {/* Show React Query DevTools in development */}
    {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
  </QueryClientProvider>
);

// Build tracking - persistent console message with bundle hash.
const BUILD_ID = '__BUILD_ID__'; // Will be injected during deployment
const BUNDLE_HASH = '__BUNDLE_HASH__'; // Will be injected during deployment

console.log('%cStormOps Dispatch build deployed', 'background: #235c4d; color: white; padding: 8px 16px; font-size: 14px; font-weight: bold; border-radius: 4px;');
console.log('%cBuild ID: ' + BUILD_ID, 'color: #235c4d; font-size: 13px; font-weight: bold;');
console.log('%cBundle Hash: main.' + BUNDLE_HASH + '.js', 'color: #1d6138; font-size: 13px; font-weight: bold;');

// Store build info globally for easy verification
window.STORMOPS_BUILD_ID = BUILD_ID;
window.STORMOPS_BUNDLE_HASH = BUNDLE_HASH;
window.STORMOPS_BUILD_INFO = { buildId: BUILD_ID, bundleHash: 'main.' + BUNDLE_HASH + '.js', deployed: new Date().toISOString() };
